import { FC } from 'react';

import { Button } from 'reactstrap';

import { IconButton } from '@hsp/react-component-library';

import { s } from '@u/strings';

import { useSecretKeyRequestConfiguration } from './hooks/configuration.hook';
import { SecretKeyRequestProps } from './types/secret-key-request.props';

const SecretKeyRequest: FC<SecretKeyRequestProps> = ({ id, name, notify, message, notificationId }) => {
  const { handleApprove, handleDeny } = useSecretKeyRequestConfiguration({ id, name, notificationId, notify });

  return (
    <div className="d-flex flex-column">
      <div className="mb-3">{message}</div>
      <div className="d-flex justify-content-end">
        <Button
          className="me-2"
          color="link"
          onClick={handleDeny}>
          {s(['Site.Deny'])}
        </Button>
        <IconButton
          color="primary"
          icon={['fas', 'user-check']}
          onClick={handleApprove}>
          {s(['Site.Approve'])}
        </IconButton>
      </div>
    </div>
  );
};

export default SecretKeyRequest;
